// VSM Field Definitions - Shared across components
// This file contains the field definitions used in vehicle_status components

export const VSM_FIELDS = [
  { key: 'delete', label: ''},
  { key: 'details', label: ''},
  { key: 'name', label: 'Vehicle'},
  { key: 'vehicle_odo', label:'Odo'},
  { key: 'vehicle_fuel', label:'Fuel'},
  { key: 'vehicle_def', label:'DEF'},
  { key: 'vehicle_status', label:'Status'},
  { key: 'maintenance_status', label:'Maint Status'},
  { key: 'unifi_status', label:'Unifi'},
  { key: 'rta_status', label:'RTA Status'},
  { key: 'rta_work_order_status', label:'RTA WO Status'},
  { key: 'wheelchair', label:'WC'},
  { key: 'stayanddo', label:'S&D'},
  { key: 'tote', label:'Tote'},
  { key: 'current_mvmt_id', label: 'Current ID'},
  { key: 'current_mvmt_driver', label: 'Current Driver'},
  { key: 'confirmed_status', label: 'Driver Confirm'},
  { key: 'confirmed_by', label: 'Confirmed By'},
  { key: 'washbay_assignment', label: 'Washbay Assignment'},
  { key: 'current_start_base', label: 'Current Start'},
  { key: 'current_finish_base', label: 'Current Finish'},
  { key: 'current_mvmt_return_time', label: 'Current Return'},
  { key: 'current_mvmt_return_eta', label: 'Return ETA'},
  { key: 'current_mvmt_pickup', label:'Current Pickup'},
  { key: 'current_mvmt_spot_time', label:'Current Spot Time'},
  { key: 'current_mvmt_destination', label:'Current Destination'},
  { key: 'last_dirty_time', label:'Last Dirty'},
  { key: 'last_cleaned_time', label:'Cleaned Time'},
  { key: 'last_cleaned_number', label:'Cleaned #'},
  { key: 'last_washed_time', label:'Washed Time'},
  { key: 'last_bathroom_cleaned_time', label:'Bathroom Cleaned'},
  { key: 'last_def_filled_time', label:'DEF Filled'},
  { key: 'last_diesel_filled_time', label:'Diesel Filled'},
  { key: 'last_fueled_time', label:'Last Fueled'},
  { key: 'last_maintenance_time', label:'Last Maint Time'},
  { key: 'last_oos_time', label:'Last OOS'},
  { key: 'last_washed_number', label:'Washed #'},
  { key: 'last_ready_time', label:'Last Ready'},
  { key: 'last_returned_time', label: 'Last Return'},
  { key: 'dump_date', label:'Dump Date'},
  { key: 'detailed_date', label:'Detailed Date'},
  { key: 'wrapped_date', label:'Wrapped Date'},
  { key: 'wrap_scheduled_time', label:'Wrap Scheduled'},
  { key: 'next_mvmt_start_base', label: 'Next Start'},
  { key: 'next_mvmt_start_finish_base', label: 'Next Start / Finish'},
  { key: 'next_mvmt_driver', label: 'Next Driver'},
  { key: 'next_mvmt_route_name', label: 'Next Route Name'},
  { key: 'next_mvmt_client_ref1_route', label: 'Reference'},
  { key: 'next_mvmt_driver_phone', label: 'Driver #'},
  { key: 'next_mvmt_id', label: 'Next ID'},
  { key: 'next_mvmt_booking_type', label:'Booking Type'},
  { key: 'next_mvmt_booking_category', label:'Booking Category', tenant_types: ['TBN'] },
  { key: 'next_mvmt_return_time', label:'Next Return'},
  { key: 'next_scheduled_time', label:'Scheduled Time'},
  { key: 'next_daily_scheduled_time', label:'Next Daily'},
  { key: 'next_scheduled_config', label:'Daily Schedule'},
  { key: 'next_mvmt_driver_time', label:'Next Driver Start'},
  { key: 'next_mvmt_driver_start', label:'Next Driver Start (TBN)'},
  { key: 'next_mvmt_time', label:'Next Depart'},
  { key: 'next_mvmt_delta', label:'Departs In'},
  { key: 'next_mvmt_days', label:'#'},
  { key: 'next_mvmt_distance', label:'Miles'},
  { key: 'next_mvmt_client_ref1', label:'Customer'},
  { key: 'next_mvmt_pickup', label:'Next Pickup'},
  { key: 'next_mvmt_destination', label:'Next Destination'},
  { key: 'odometer', label:'Odometer'},
  { key: 'fuel_level', label:'Fuel'},
  { key: 'def_level', label:'DEF'},
  { key: 'notes', label: 'Notes'},
  { key: 'update_status', label: ''},
]

// Curated default column sets for tenant VSM settings "Reset to Default"
export const VSM_MAIN_DEFAULT_FIELD_KEYS = [
  'details',
  'name',
  'vehicle_status',
  'maintenance_status',
  'next_mvmt_id',
  'next_mvmt_driver',
  'next_mvmt_time',
  'next_mvmt_delta',
  'notes',
]

export const VSM_MOBILE_DEFAULT_FIELD_KEYS = ['name', 'vehicle_status', 'next_mvmt_delta']

export const VSM_HISTORY_DEFAULT_FIELD_KEYS = [
  'processed_time',
  'updated_by',
  'vehicle_status',
  'vehicle_name',
  'last_cleaned_time',
  'last_washed_time',
  'last_returned_time',
  'notes',
]

function defaultVisibleFieldsString(availableFields, defaultKeys) {
  if (!availableFields || !availableFields.length || !defaultKeys || !defaultKeys.length) return ''
  const availableKeys = new Set(availableFields.map(f => f.key))
  return defaultKeys.filter(k => availableKeys.has(k)).join(',')
}

export function defaultMainVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_MAIN_DEFAULT_FIELD_KEYS)
}

export function defaultMobileVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_MOBILE_DEFAULT_FIELD_KEYS)
}

export function defaultHistoryVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_HISTORY_DEFAULT_FIELD_KEYS)
}

export const VSM_HISTORY_FIELDS = [
  { key: 'processed_time', label:'Last Updated'},
  { key: 'updated_by', label:'Updated By'},
  { key: 'vehicle_status', label:'Status'},
  { key: 'vehicle_name', label:'Vehicle'},
  { key: 'maintenance_status', label:'Maint Status'},
  { key: 'confirmed_status', label: 'Driver Confirm'},
  { key: 'confirmed_by', label: 'Confirmed By'},
  { key: 'booking_hash', label:'Booking'},
  { key: 'last_dirty_time', label:'Dirty'},
  { key: 'last_cleaned_time', label:'Cleaned'},
  { key: 'last_cleaned_number', label:'Cleaned #'},
  { key: 'last_washed_time', label:'Washed'},
  { key: 'last_washed_number', label:'Washed #'},
  { key: 'last_bathroom_cleaned_time', label:'Bathroom Cleaned'},
  { key: 'last_def_filled_time', label:'DEF Filled'},
  { key: 'last_diesel_filled_time', label:'Diesel Filled'},
  { key: 'last_fueled_time', label:'Last Fueled'},
  { key: 'last_ready_time', label:'Ready'},
  { key: 'last_out_time', label:'Last Out'},
  { key: 'last_returned_time', label: 'Returned Time'},
  { key: 'detailed_date', label:'Detailed Date'},
  { key: 'wrapped_date', label:'Wrapped Date'},
  { key: 'dump_date', label:'Dump Date'},
  { key: 'dumped_date', label:'Dumped Date'},
  { key: 'next_scheduled_time', label:'Scheduled Time'},
  { key: 'odometer', label:'Odometer'},
  { key: 'fuel_level', label:'Fuel'},
  { key: 'def_level', label:'DEF'},
  { key: 'notes', label: 'Notes'},
]

// Helper function to convert comma-delimited string to array of field objects
export function stringToFields(fieldString, allFields) {
  if (!fieldString || !allFields) return []
  const keys = fieldString.split(',').map(k => k.trim()).filter(k => k)
  return keys.map(key => {
    const field = allFields.find(f => f.key === key)
    return field || { key, label: key }
  })
}

// Helper function to convert array of field objects to comma-delimited string
export function fieldsToString(fields) {
  if (!fields || !Array.isArray(fields)) return ''
  return fields.map(f => f.key).join(',')
}

// Helper function to get available fields (not in selected list)
export function getAvailableFields(allFields, selectedFields) {
  const selectedKeys = selectedFields.map(f => f.key)
  return allFields.filter(f => !selectedKeys.includes(f.key))
}

export function maintStatusSelectValue(status, dvirCombined = false) {
  if (!status) return status
  if (dvirCombined && (status === 'PENDING_DVIR' || status === 'UNSAFE_DVIR'))
    return 'DVIR'
  return status
}

export function displayMaintStatus(status, dvirCombined = false) {
  if (!status) return status
  if (dvirCombined && (status === 'PENDING_DVIR' || status === 'UNSAFE_DVIR'))
    return 'DVIR'
  if (status.endsWith('_DVIR'))
    return status.slice(0, -5)
  return status
}
